import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-g_map_on",
  "use": "icon-g_map_on-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-g_map_on\"><defs><style type=\"text/css\"></style></defs><path d=\"M708.6336 351.515733 610.798933 579.867733 456.4736 426.289067 685.998933 329.009067C707.8656 319.729067 717.9136 329.841067 708.6336 351.515733L708.6336 351.515733ZM354.0736 704.113067C332.206933 713.371733 322.158933 703.259733 331.438933 681.6064L427.438933 457.585067 579.268267 608.689067 354.0736 704.113067ZM512.004267 42.673067C252.804267 42.673067 42.670933 252.785067 42.670933 512.0064 42.670933 771.2064 252.804267 981.339733 512.004267 981.339733 771.204267 981.339733 981.3376 771.2064 981.3376 512.0064 981.3376 252.785067 771.204267 42.673067 512.004267 42.673067L512.004267 42.673067Z\" p-id=\"3380\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/g_map_on.svg
// module id = AgJs
// module chunks = 31